import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Reservation } from '@app/models/micro/reservation.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Passenger } from '@app/models/micro';
import { PassengerService } from '@app/services/micro/passenger.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiAncillaries } from '@app/services/micro/ancillaries.service';
import { GlobalsService } from '@app/services/micro/globals.service';
import { FARES_FAMILY } from '@app/enums';
import { environment } from '@env/environment';
@Component({
    selector: 'app-carryon-add-modal',
    templateUrl: './carryon-add-modal.component.html',
    styleUrls: ['./carryon-add-modal.component.scss'],
    standalone: false
})
export class CarryonAddModalComponent implements OnInit {

  @Input() typeModal: 'offer' | 'bag' = 'bag';
  @Input() tarif:string;

  @Output() onChangeExtraWeight: EventEmitter<boolean> = new EventEmitter<boolean>();
  reservation: Reservation;
  tittle: string;
  statusBag: boolean = false; // CI-19083: Estado del checkbox para controlar botones
  statusBox = true;
  currentLanguage
  passengerSelected: Passenger[];
  constructor(
    private modalService: NgbModal,
    private _passengers: PassengerService,
    private _router: Router,
    private _translateService: TranslateService,
    private _ancillaries: ApiAncillaries,
    private _globalService: GlobalsService,
    private _passengerService: PassengerService,
  ) { }

  ngOnInit() {
    this.initPage();
    this.currentLanguage = this._translateService.currentLang.replace("-", "_")
  }

  ngOnDestroy(): void {
  }

  initPage() {
    this.tittle = 'carryonOfferModalAdd.titleOffer';
    this.reservation = this._globalService.getReservation();
    this.passengerSelected = this._passengerService.getPassengerSelection();
  }
  /**
    Cierra todos los modales abiertos.
    Este método se ejecuta cuando el usuario decide cerrar el modal.
    @return void - No retorna ningún valor.
  **/
  onClose() {
    this.modalService.dismissAll();
    // this._router.navigate(['/review-bags/bagSelectionCarryonClassic']);
  }
  onHandleCheck(value: boolean) {
    this.statusBag = value;
    this.onChangeExtraWeight.next(value);
  }

  redirect() {
    this.getAncillaries();
    this.modalService.dismissAll();
  }

  getAncillaries() {
    const navigateToBags = () => {
      const route = environment.kioskPermissions.enableUnifiedBagSelection
        ? '/review-bags/unifiedBagSelection'
        : this.tarif === FARES_FAMILY.MAIN_LIGHT
        ? '/review-bags/bagSelectionCarryonBasic'
       : '/review-bags/bagSelectionCarryonClassic';
    this._globalService.originFlowBags = route
    this._router.navigate([route]);
  };
    if(!this.hasBagOffersCarryOn) {
    this._ancillaries.getAncillaries(this.reservation).subscribe({
      next: (response) => {
        const passengers = this.passengerSelected;
        const { passengers: passengersResponse } = response;
        this.reservation.overWeight = response.overweight;
        for (const passenger of passengers) {
          const paxResponse = passengersResponse.find(
            (r) => r.referenceNumber === passenger.nameRefNumber
          );
          passenger.bagOfferStack = paxResponse?.extraBags?.filter(bag => !!bag.applyTo.includes(passenger.nameRefNumber)) || [];
          passenger.initializeBagOfferCarryOnStack(paxResponse?.carryOn || []);
        }
        this._passengerService.setSelectPassengersToBags(this.passengerSelected);
       navigateToBags()
      }
    })
     }else{
      this._passengerService.setSelectPassengersToBags(this.passengerSelected);
       navigateToBags()
     }
  }

  get hasBagOffersCarryOn(): boolean {
    return this.reservation.passengers.some(
      (p) =>
        p.bagOfferStack?.length > 0 &&
        p.bagOfferCarryOnStack?.length > 0
    );
  }

}
